import { decodeHTML } from 'entities';
// NOTE (2023-04-17): need version 1.0.13 otherwise '<' and anything following in strings gets trimmed
// in version 1.0.14 this is broken, maybe future versions will not be
import xss from 'xss';

/**
 * Plain-text sanitizers (strings in, strings out).
 *
 * These are imported by eagerly-loaded code (urls.ts, header hooks, reducers), so this module
 * must stay free of html-react-parser — the React-rendering `safelyRender` lives in
 * `utils/safelyRender.ts` and is only imported from code-split page components.
 */

// remove scripts and styles, strip all tags
// @ts-ignore
export const bruteFilter = new xss.FilterXSS({
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
    whiteList: {},
});

export const sanitizeHtml = (text: string): string => decodeHTML(xss(text));

export const sanitizeHeaderText = (text: string): string => decodeHTML(removeHtml(text)).replace(/\s\s+/g, ' ');

const cleanSpace = (text: string): string => text.replace(/\s/g, ' ');

const removeHtml = (text: string): string => {
    let safeHtml = bruteFilter.process(text);
    safeHtml = cleanSpace(safeHtml);
    return safeHtml;
};

/**
 * remove all html and return a text string - also subs space for <br/> and <li> tags
 */
const removeHtmlWithLineBreaks = (text: string): string => {
    let manuallyCleanedHtml = text || '';
    manuallyCleanedHtml = manuallyCleanedHtml.replace(/<br ?\/?>/g, ' ');
    manuallyCleanedHtml = manuallyCleanedHtml.replace(/<li>/g, ' ').trimStart();
    return removeHtml(manuallyCleanedHtml);
};

/**
 * sanitizes meta data by removing HTML, and replaces whitespace characters with single spaces
 */
export const safelyEscapeText = (text: string): string =>
    sanitizeHtml(removeHtmlWithLineBreaks(text)).replace(/\s\s+/g, ' ');

/**
 * sanitizes meta data by removing HTML
 */
export const safelyEscapeTextSpaceful = (text: string): string => sanitizeHtml(removeHtmlWithLineBreaks(text));
